export const NGO_PARTNERS = [
  {
    id: 'anish-jadhav',
    name: 'Anish Jadhav Memorial Foundation',
    sub: 'Navgurukul Campus Pune',
    logo: '/img/ngo-partners/anish-jadhav.png',
    website: 'https://anishjadhavmemorialfoundation.org/'
  },
  {
    id: 'navgurukul',
    name: 'Navgurukul Foundation',
    sub: 'Pan-India Residential Campuses',
    logo: '/img/ngo-partners/navgurukul.png'
  },
  {
    id: 'unicef',
    name: 'UNICEF',
    sub: 'Digital Learning Partner',
    logo: '/img/ngo-partners/unicef.png'
  },
  {
    id: 'aif',
    name: 'American India Foundation',
    sub: 'Digital Equalizer Initiative',
    logo: '/img/ngo-partners/aif.png'
  },
  {
    id: 'quest-alliance',
    name: 'Quest Alliance',
    sub: 'Youth Skilling & EdTech',
    logo: '/img/ngo-partners/quest-alliance.png'
  },
  {
    id: 'def',
    name: 'Digital Empowerment Foundation',
    sub: 'Community Information Resource Centres',
    logo: '/img/ngo-partners/def.png'
  },
  {
    id: 'deshpande',
    name: 'Deshpande Skilling',
    sub: 'Rural Youth Skilling',
    logo: '/img/ngo-partners/deshpande.png'
  },
  {
    id: 'convegenius',
    name: 'ConveGenius',
    sub: 'AI-driven Learning Labs',
    logo: '/img/ngo-partners/convegenius.png'
  },
  {
    id: 'computer-shiksha',
    name: 'Computer Shiksha',
    sub: 'Digital Literacy for Underprivileged',
    logo: '/img/ngo-partners/computer-shiksha.png'
  },
  {
    id: 'asha-chennai',
    name: 'Asha Chennai',
    sub: 'Rural Schools Technology',
    logo: '/img/ngo-partners/asha-chennai.png'
  },
  {
    id: 'medha',
    name: 'Medha',
    sub: 'Employability & Career Education',
    logo: '/img/ngo-partners/medha.png'
  },
  {
    id: 'peepul',
    name: 'Peepul',
    sub: 'Government School Transformation',
    logo: '/img/ngo-partners/peepul.png'
  },
  {
    id: 'pi-jam',
    name: 'Pi Jam Foundation',
    sub: 'Creative Computing & Problem Solving',
    logo: '/img/ngo-partners/pi-jam.png'
  },
  {
    id: 'sewa',
    name: 'SEWA Bharat',
    sub: 'Women Micro-entrepreneurs & Skilling',
    logo: '/img/ngo-partners/sewa.png'
  },
  {
    id: 'youth4jobs',
    name: 'Youth4Jobs',
    sub: 'Empowering Persons with Disabilities',
    logo: '/img/ngo-partners/youth4jobs.png'
  },
  {
    id: 'llf',
    name: 'Language and Learning Foundation',
    sub: 'Foundational Literacy & Tech',
    logo: '/img/ngo-partners/llf.png'
  },
  {
    id: 'leadership-for-equity',
    name: 'Leadership For Equity',
    sub: 'Systemic Education Reform',
    logo: '/img/ngo-partners/leadership-for-equity.png'
  },
  {
    id: 'waste-warriors',
    name: 'Waste Warriors',
    sub: 'Sustainable E-waste & Green Recovery',
    logo: '/img/ngo-partners/waste-warriors.png'
  },
  {
    id: 'bala-vikasa',
    name: 'Bala Vikasa',
    sub: 'Community Development',
    logo: '/img/ngo-partners/bala-vikasa.png'
  },
  {
    id: 'barabari-collective',
    name: 'Barabari Collective',
    sub: 'Gender & Digital Equity',
    logo: '/img/ngo-partners/barabari-collective.png'
  },
  {
    id: 'bachpan-banao',
    name: 'Bachpan Banao',
    sub: 'Dantewada Education Initiative',
    logo: '/img/ngo-partners/bachpan-banao.png'
  },
  {
    id: 'code-to-enhance',
    name: 'Code to Enhance Plan',
    sub: 'Girls in Technology',
    logo: '/img/ngo-partners/code-to-enhance.png'
  },
  {
    id: 'atamdeepam',
    name: 'Atamdeepam Society',
    sub: 'Grassroots Empowerment',
    logo: '/img/ngo-partners/atamdeepam.png'
  },
  {
    id: 'fia',
    name: 'Foundation For Innovation & Action',
    sub: 'Public Systems Innovation',
    logo: '/img/ngo-partners/fia.png'
  },
  {
    id: 'jan-shaurya',
    name: 'Jan Shaurya',
    sub: 'Youth Social Leadership',
    logo: '/img/ngo-partners/jan-shaurya.png'
  },
  {
    id: 'lcf',
    name: 'LCF',
    sub: 'Learning Communities',
    logo: '/img/ngo-partners/lcf.png'
  },
  {
    id: 'nazariya',
    name: 'Nazariya Arts Collective',
    sub: 'Creative Computing',
    logo: '/img/ngo-partners/nazariya.png'
  },
  {
    id: 'nirnaya',
    name: 'Nirnaya',
    sub: 'Women’s Livelihood Trust',
    logo: '/img/ngo-partners/nirnaya.png'
  },
  {
    id: 'paper-crane-lab',
    name: 'Paper Crane Lab',
    sub: 'Hands-on STEM & Computing',
    logo: '/img/ngo-partners/paper-crane-lab.png'
  },
  {
    id: 'pifinity',
    name: 'Pifinity Education Foundation',
    sub: 'Digital Classroom Labs',
    logo: '/img/ngo-partners/pifinity.png'
  },
  {
    id: 'project-shiksha',
    name: 'Project Shiksha',
    sub: 'Rural Digital Literacy',
    logo: '/img/ngo-partners/project-shiksha.png'
  },
  {
    id: 'sssim',
    name: 'SSSIM',
    sub: 'Skill Development Institute',
    logo: '/img/ngo-partners/sssim.png'
  },
  {
    id: 'sanjhi-sikhiya',
    name: 'Sanjhi Sikhiya',
    sub: 'Punjab Education Collective',
    logo: '/img/ngo-partners/sanjhi-sikhiya.png'
  },
  {
    id: 'signsetu',
    name: 'Signsetu',
    sub: 'Accessibility & Inclusion',
    logo: '/img/ngo-partners/signsetu.png'
  },
  {
    id: 'tis',
    name: 'The Innovation Story (TIS)',
    sub: 'Next-gen Tech Literacy',
    logo: '/img/ngo-partners/tis.png'
  },
  {
    id: 'trrain',
    name: 'TRRAIN',
    sub: 'Retail & Livelihood Training',
    logo: '/img/ngo-partners/trrain.png'
  },
  {
    id: 'trutiya-ratna',
    name: 'Trutiya Ratna',
    sub: 'Social Justice & Education',
    logo: '/img/ngo-partners/trutiya-ratna.png'
  },
  {
    id: 'visthar',
    name: 'Visthar',
    sub: 'Community Development Academy',
    logo: '/img/ngo-partners/visthar.png'
  },
  {
    id: 'eklavya',
    name: 'Eklavya Foundation',
    sub: 'Educational Innovation',
    logo: '/img/ngo-partners/eklavya.png'
  },
  {
    id: 'esther',
    name: 'Esther Foundation',
    sub: 'Girls Leadership',
    logo: '/img/ngo-partners/esther.png'
  },
  {
    id: 'ei',
    name: 'Educational Initiatives',
    sub: 'Learning Assessment & Tech',
    logo: '/img/ngo-partners/ei.png'
  }
];

export default NGO_PARTNERS;
